import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  attributeName: 'billingtransactionsmonthdetail',
  isDragable: false,
  canOpen: false,
  canEdit: false,
  canCreate: false,
  canRemove: false,
  getURL: 'billingtransactionmonth',
  idAttribute: 'id',
  emptyMessage: "There is no provider associated",
  fields: [
    {
      attributeName: 'appName',
      label: 'App Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: true,
      canFilter:true,
      canEdit: false,
      canCreate: false,
      helpText: 'Name of the category.',
    },
    {
      attributeName: 'name',
      label: 'Provider Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: true,
      canFilter:true,
      canEdit: false,
      canCreate: false,
      helpText: 'Name of the category.',
    }
  ],
};
